import {
  loadingOpen,
  loadingClose,
} from '../mutations_type';

import userService from '../../services/user'

const types = {
  LOGIN_USERNAME_ERROR: 'userService/login_username_error',
  LOGIN_ERROR: 'userService/login_error',
  LOGIN_ERROR_RESET: 'userService/login_error_reset',

  REGISTER_STEP: 'userService/register_step',
  REGISTER_INDEX: 'userService/register_index',
  REGISTER_ERROR: 'userService/register_error',

  REGISTER_ERROR_RESET: 'userService/register_error_reset',

  SET_NEXT_URI: 'userService/set_next_uri',

  RESET_PASSWORD_LAYOUT: 'userService/reset_password_layout',

  FORGETPASSWORD_LAYOUT: 'userService/forgetpassword_layout',
};

const state = {
  loginUsernameError: '',
  loginError: '',

  registerStep: 'register',
  registerIndex: 1,
  registerError: null,
  nextUri: '',

  inputNewEmailSubmit: false,

  resetPasswordLayout: 'isNormal', // isNormal, isError, isSuccess

  forgetPasswordLayout: 'isNormal', // isNormal, isError
};

const getters = {
  loginUsernameError: s => s.loginUsernameError,
  loginError: s => s.loginError,

  registerStep: s => s.registerStep,
  registerIndex: s => s.registerIndex,
  registerError: s => s.registerError,
  nextUri: s => s.nextUri,

  resetPasswordLayout: s => s.resetPasswordLayout,

  forgetPasswordLayout: s => s.forgetPasswordLayout,
};

const actions = {
  validUsername({ commit }, { formData }) {
    commit(loadingOpen)

    userService.validUsername({
      formData
    })
    .then(res => {
      const {
        data
      } = res

      commit(loadingClose)

      data.result
      ? commit(types.LOGIN_USERNAME_ERROR, '')
      : commit(types.LOGIN_USERNAME_ERROR, data.msg)
    })
    .catch((err) => {
      commit(loadingClose)
      console.log('error')
    })
  },

  loginByEmail({ commit }, { formData }) {
    commit(loadingOpen)

    userService.loginByEmail({
      formData
    })
    .then(res => {
      const {
        data
      } = res

      commit(loadingClose)

      data.result
      ? window.location.href = data.next_uri
      : commit(types.LOGIN_ERROR, data.msg)
    })
    .catch((err) => {
      commit(loadingClose)
      console.log('error')
    })
  },

  registerByEmail({ commit }, {formData}) {
    commit(loadingOpen)

    userService.registerByEmail({
      formData
    })
    .then(res => {
      const {
        data
      } = res

      data.result
      ? (
        commit(types.REGISTER_STEP, 'info'),
        commit(types.REGISTER_INDEX, 2)
      )
      : commit(types.REGISTER_ERROR, data.msg)

      commit(loadingClose)
    })
    .catch(error => {
      commit(loadingClose)
      console.log('error')
    })
  },

  registerInfo({ commit }, { formData }) {
    commit(loadingOpen)

    userService.registerInfo({
      formData
    })
    .then(res => {
      const {
        data
      } = res

      data.result
      ? (
        commit(types.SET_NEXT_URI, data.next_uri),
        commit(types.REGISTER_INDEX, 3)
      )
      : null

      commit(loadingClose)
    })
    .catch(error => {
      commit(loadingClose)
      console.log('error')
    })
  },

  forgetPassword({ commit }, {
    formData,
    router
  }) {
    commit(loadingOpen)

    userService.forgetPassword({
      formData
    })
    .then(res => {
      const {
        data
      } = res

      commit(loadingClose)

      data.result
      ? router.push({name: 'reset_password'})
      : commit(types.FORGETPASSWORD_LAYOUT, 'isError')
    })
    .catch(error => {
      commit(loadingClose)
      console.log('error')
    })
  },

  setForgetPasswordLayout({ commit }, {
    layout
  }) {
    commit(types.FORGETPASSWORD_LAYOUT, layout)
  },

  resetPassword({ commit }, {
    formData
  }) {
    commit(loadingOpen)

    userService.resetPassword({
      formData
    })
    .then(res => {
      const {
        data
      } = res

      commit(loadingClose)

      data.result
      ? commit(types.RESET_PASSWORD_LAYOUT, 'isSuccess')
      : commit(types.RESET_PASSWORD_LAYOUT, 'isError')
    })
    .catch(error => {
      commit(loadingClose)
      console.log('error')
    })
  },

  setResetPasswordLayout({ commit }, {
    layout
  }) {
    commit(types.RESET_PASSWORD_LAYOUT, layout)
  },

  setRegisterStep({ commit }, {
    stepName
  }) {
    commit(types.REGISTER_STEP, stepName)
  },

  setRegisterStepIndex({ commit }, {
    stepIndex
  }) {
    commit(types.REGISTER_INDEX, stepIndex)
  },

  resetRegisterError({ commit }) {
    commit(types.REGISTER_ERROR_RESET)
  },

  resetLoginError({ commit }) {
    commit(types.REGISTER_ERROR_RESET)
  },
};

// mutations
const mutations = {
  [types.LOGIN_USERNAME_ERROR](s, r) {
    s.loginUsernameError = r
  },

  [types.LOGIN_ERROR](s, t) {
    s.loginError = t;
  },

  [types.LOGIN_ERROR_RESET](s) {
    s.loginError = '';
  },

  [types.REGISTER_STEP](s, t) {
    s.registerStep = t;
  },

  [types.REGISTER_INDEX](s, index) {
    s.registerIndex = index;
  },

  [types.REGISTER_ERROR](s, error) {
    s.registerError = error
  },

  [types.REGISTER_ERROR_RESET](s) {
    s.registerError = null
  },

  [types.SET_NEXT_URI](s, uri) {
    s.nextUri = uri;
  },

  [types.RESET_PASSWORD_LAYOUT] (s, layoutType) {
    s.resetPasswordLayout = layoutType
  },

  [types.FORGETPASSWORD_LAYOUT] (s, layoutType) {
    s.forgetPasswordLayout = layoutType
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
